import * as React from "react";
import CardBox from "@src/components/ui/CardBox";
import Loading from "@src/components/ui/Loading";
import ModuloRegistrazione from "@src/components/frontend/ModuloRegistrazione";
import { api, user } from "@src/services/api";

interface Props {
  profilo?: boolean;
  categorie?: string[];
}

interface State {
  loading: boolean;
  saved: boolean;
  cards: number;
  prev_card: number;
  type: number;
  index: number | null;
  user?: any;
  accountSteps: any;
}

const USERTYPES = [
  {
    key: 5,
    categoria: 'gestore',
    label: "Gestore scuola pubblica",
    icon: "icon-tree_structure",
    description:
      "Per coloro che gestiscono come animatori digitali l’area web di una scuola o di una struttura scolastica <strong>pubblica</strong>.",
    params: {
        ruolo: "Professionale",
        id_categoria: 1,
    }
  },
  {
    key: 5,
    categoria: 'gestore',
    label: "Gestore scuola privata",
    icon: "icon-networking_manager",
    description:
      "Per coloro che gestiscono una scuola o una struttura educativa/formativa <strong>privata</strong> di ogni ordine e grado.",
    params: {
        ruolo: "Professionale",
        id_categoria: 1,
    }
  },
  {
    key: 2,
    categoria: 'studente',
    label: "Studente",
    icon: "icon-student_male_filled",
    description:
      "Per gli <strong>studenti</strong> che vogliono recensire una scuola frequentata e/o sono alla ricerca di un insegnante per fare ripetizioni.",
    params: {
        ruolo: "Privato"
    }
  },
  {
    key: 1,
    categoria: 'genitore',
    label: "Genitore",
    icon: "icon-parent_guardian",
    description:
      "Per i <strong>genitori o nonni</strong> che vogliono recensire una scuola e/o sono alla ricerca di una tata/babysitter per i loro bimbi.",
    params: {
        ruolo: "Privato",
        sono_un_genitore: true
    }
  }
];

export default class SceltaAccount extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      saved: false,
      cards: 1,
      prev_card: 1,
      type: 0,
      index: null,
      accountSteps: [
        [1, 99],
        [1, 17, 99],
        [1, 6, 15, 11, 14, 12, 16, 13, 99],
        [1, 6, 2, 7, 8, 9, 10, 99],
        [1, 17, 18, 99]
      ]
    } as State;
  }

  setCardsLevel(level) {
    this.setState({
      prev_card: this.state.cards,
      cards: level
    });
  }

  setTipoAccount(type, index) {
    this.setState({
      prev_card: this.state.cards,
      cards: 0,
      type: type,
      index: index
    });
  }

  saveTipoAccount() {
    const { type } = this.state;
    api({
      method: "POST",
      url: `users/${user.id}/update/type`,
      data: USERTYPES.filter( U => U.key === type )[0].params
    })
      .then(response => {
        this.setState({
          saved: true
        });
      })
      .catch(response => {
        alert({
          text: response,
          type: "error"
        });
      });
  }

  componentDidMount() {
    // console.log('user', user);
    this.getUser(user.id, response => {
      console.log("danilo", response);

      const { ruolo, categoria, sono_un_genitore } = response;

      let type = null;

      console.log("user", ruolo, categoria, sono_un_genitore);

      if (ruolo === null) {
        return;
      }

      if (ruolo === "Privato") {
        if (sono_un_genitore == 1) {
          type = 1;
        } else {
          type = 2;
        }
      } else if (ruolo === "Professionale" && categoria.length > 0) {
        switch (categoria[0].id) {
          case 2:
            type = 3;
            break;
          case 5:
            type = 4;
            break;
          case 1:
            type = 5;
            break;
        }
      }

      if (type !== null) {
        this.setState({
          saved: true,
          user: response,
          prev_card: this.state.cards,
          cards: 0,
          type: type
        });
      }
    });
  }

  componentDidUpdate() {}

  getUser(id, callback) {
    api({
      method: "GET",
      url: `users/${id}`
    }).then(response => {
      console.log("response", response);
      callback(response);
    });
  }

  render() {
    const { profilo = false, categorie } = this.props;
    const { loading, saved, cards, type, index } = this.state;

    if (loading) return <Loading />;

    var $USERTYPES = USERTYPES;
    if (categorie) {
      $USERTYPES = USERTYPES.filter( u => categorie.indexOf(u.categoria) !== -1);
    }

    if (!saved) {
      return (
          <div className="container">
            <div className="row">
              <div className="col-sm-offset-1 col-sm-10">
                <div className="frontend_SceltaAccount">
                  <header>
                    <h2>Che tipo di profilo vuoi creare?</h2>
                  </header>
                  {$USERTYPES.map(({ key, label, icon, description }, i) => (
                    <article
                      className={index === i ? "active" : ""}
                      key={i}
                      onClick={() => this.setTipoAccount(key, i)}
                    >
                      <h3>
                        <span className={icon} />
                        {label}
                      </h3>
                      <p dangerouslySetInnerHTML={{ __html: description }} />
                      {index === i && (
                        <div>
                          <br />
                          <button
                            className={"btn-next right-button"}
                            onClick={() => this.saveTipoAccount()}
                          >
                          Prosegui <i className={"icon-next"} />
                          </button>
                        </div>
                      )}
                    </article>
                  ))}
                  <footer>
                    <span />
                    {/*<button className={"btn-back left-button"} onClick={() => {}}>
                      <i className={"icon-prev"} /> Indietro
                    </button>*/}
                  </footer>
                </div>
              </div>
            </div>
          </div>
      );
    } else {
      return (
        <ModuloRegistrazione
          account={this.state.type}
          onBack={() => this.setCardsLevel(this.state.prev_card)}
          profilo={profilo}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/frontend/SceltaAccount.tsx